// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeDebitCardApi = class EdgeDebitCardApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param getDebitCardDetailRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async debitCardGetDebitCardDetail(getDebitCardDetailRequestModel, xProgramId) {
        const _url_ = '/edge/debitCard/GetDebitCardDetail';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getDebitCardDetailRequestModel' is not null or undefined
        if (getDebitCardDetailRequestModel === null || getDebitCardDetailRequestModel === undefined) {
            throw new Error('Required parameter getDebitCardDetailRequestModel was null or undefined when calling debitCardGetDebitCardDetail.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getDebitCardDetailRequestModel, "GetDebitCardDetailRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardGetDebitCardDetailDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getLashPatientDebitCardLast4RequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async debitCardGetLashPatientDebitCardLast4(getLashPatientDebitCardLast4RequestModel, xProgramId) {
        const _url_ = '/edge/debitCard/GetLashPatientDebitCardLast4';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getLashPatientDebitCardLast4RequestModel' is not null or undefined
        if (getLashPatientDebitCardLast4RequestModel === null || getLashPatientDebitCardLast4RequestModel === undefined) {
            throw new Error('Required parameter getLashPatientDebitCardLast4RequestModel was null or undefined when calling debitCardGetLashPatientDebitCardLast4.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getLashPatientDebitCardLast4RequestModel, "GetLashPatientDebitCardLast4RequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardGetLashPatientDebitCardLast4DefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param getDebitCardDetailRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async debitCardV2DebitCardDetail(getDebitCardDetailRequestModel, xProgramId) {
        const _url_ = '/edge/debitCard/v2/DebitCardDetail';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'getDebitCardDetailRequestModel' is not null or undefined
        if (getDebitCardDetailRequestModel === null || getDebitCardDetailRequestModel === undefined) {
            throw new Error('Required parameter getDebitCardDetailRequestModel was null or undefined when calling debitCardV2DebitCardDetail.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(getDebitCardDetailRequestModel, "GetDebitCardDetailRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DebitCardV2DebitCardDetailDefaultResponse");
        }
        return response;
    }
};
EdgeDebitCardApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeDebitCardApi);
export { EdgeDebitCardApi };
//# sourceMappingURL=edgeDebitCardApi.js.map